import type { AssetSort, GroupSort, SortDirection } from '@scio3/shared-types';
import type { AssetSortField } from '../stores/asset-sort-store';

export function buildSortInput(sortField: AssetSortField, sortDirection: SortDirection): AssetSort {
  return { [sortField]: sortDirection };
}

/**
 * Builds sort input for the groups (folders) query.
 * Maps asset sort fields to group sort fields:
 * - `originalFileName` → `name` (groups use `name` field)
 * - `createdAt`, `lastUpdatedDate` → pass through
 */
export function buildGroupSortInput(
  sortField: AssetSortField,
  sortDirection: SortDirection,
): GroupSort {
  const groupField = sortField === 'originalFileName' ? 'name' : sortField;
  return { [groupField]: sortDirection };
}
